import React, { FunctionComponent } from 'react';

import { OurCommunityCard } from './OurCommunityCard';
import firstCommentImage from './assets/lewis_thumb.png';
import secondCommentImage from './assets/caroline_thumb.png';
import styles from './OurCommunity.module.scss';
import thirdCommentImage from './assets/meredith_niles.png';
import { useTranslation } from 'react-i18next';

export const OurCommunity: FunctionComponent = () => {
  const allowedLanguages = ['en', 'en-GB'];
  const { i18n } = useTranslation();
  const showOurCommunity =
    i18n.language && allowedLanguages.indexOf(i18n.language) !== -1;
  if (!showOurCommunity) {
    return null;
  }
  return (
    <div className={styles.communityComments}>
      <div className="jg-grid-container">
        <section className="jg-grid-row">
          <h2 className={`${styles.communityCommentsHeader} jg-h1`}>
            Our community
          </h2>
          <p className={`${styles.communityCommentsSubHeader} jg-text-xl`}>
            People like you do amazing things on JustGiving every day!
          </p>
          <div
            className={`jg-grid-col-s-12 jg-grid-col-l-10 ${styles.communityCommentContainer}`}
          >
            <div className={styles.communityCommentAvatarContainer}>
              <div
                className={`${styles.communityCommentAvatar} ${styles.commentImage}`}
              >
                <img src={firstCommentImage} alt="" />
              </div>
            </div>

            <OurCommunityCard
              className={styles.speechBubbleLeft}
              blockquoteDescription=' "The surgery I needed was only available privately - I
            couldn’t afford it on my own. Crowdfunding helped me raise the
            money I needed. I underwent the operation this month and it’s
            completely changed my life."'
              figcaption="Lewis Grant"
            >
              <div
                className={`jg-show-block-from-l jg-text-l ${styles.raiseStats}`}
              >
                Raised <strong className={styles.raisedValue}>£1,980</strong>{' '}
                with <strong className="jg-h5">77 supporters</strong>
              </div>
            </OurCommunityCard>
          </div>
          <div
            className={`jg-grid-col-s-12 jg-grid-col-l-10 ${styles.communityCommentContainer} ${styles.containerReverseDisplay}`}
          >
            <OurCommunityCard
              className={styles.speechBubbleRight}
              blockquoteDescription=' "Through JustGiving, you get some wonderful messages from
              people I’ll never meet, but they are very much
              part of my charity campaign and I`m doing it for them. 
              When people say this is inspirational, I think I do have to see this through,
               and I will see it through and I`m very proud of it."'
              figcaption="Caroline Jones"
            >
              <div
                className={`jg-show-block-from-l jg-text-l ${styles.raiseStats}`}
              >
                Raised <strong className={styles.raisedValue}>£50,188</strong>{' '}
                with <strong className="jg-h5">1479 supporters</strong>
              </div>
            </OurCommunityCard>

            <div className={styles.commentAvatarReverseDisplay}>
              <div className={styles.communityCommentAvatarContainer}>
                <div
                  className={`${styles.communityCommentAvatar} ${styles.commentImage}`}
                >
                  <img src={secondCommentImage} alt="" />
                </div>
              </div>
            </div>
          </div>

          <div
            className={`jg-grid-col-s-12 jg-grid-col-l-10 ${styles.communityCommentContainer}`}
          >
            <div className={styles.communityCommentAvatarContainer}>
              <div
                className={`${styles.communityCommentAvatar} ${styles.commentImage}`}
              >
                <img src={thirdCommentImage} alt="" />
              </div>
            </div>

            <OurCommunityCard
              className={styles.speechBubbleLeft}
              blockquoteDescription=' "The best-ever lottery ticket, combined with the most affordable and effective insurance policy there is."'
              figcaption="Meredith Niles, Strategy and Innovation Director, Marie Curie UK"
            />
          </div>
        </section>
      </div>
    </div>
  );
};
